module.exports = __webpack_public_path__ + "static/trees-3162c9df2cc0b8fc5132fcd6bd339c90.png";